import { render, staticRenderFns } from "./ShipmentAlertCollapse.vue?vue&type=template&id=d5baab94&"
import script from "./ShipmentAlertCollapse.vue?vue&type=script&lang=js&"
export * from "./ShipmentAlertCollapse.vue?vue&type=script&lang=js&"
import style0 from "~/assets/scss/sections/searchbar-criteria/search-bar-criteria.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports